<template>
  <div class="hello row">
    <welcome-left-link class="col-xl-2 col-lg-3"></welcome-left-link>
    <div class="col-xl-10 col-lg-9">
      <h2>Project Expenditure Authorization (PEA) Home</h2>
      <hr />
      This site allows any Teleflex employee to raise an approval request (PEA) for a planned project or capital expenditure.
      <br /><br />
      Although anyone can raise a PEA you must have checked with the necessary approval authorities at your local facility before raising a PEA. Your submitted PEA will be subject to an approval process which depends on its value.
      <br /><br />

      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>

      <div v-loading="isLoading">
        <!-- no action -->
        <div v-if="isLoading == false && awaitingApprovalsCount == 0 && upcomingApprovalsCount == 0 && recentAuthorizedCount == 0 && awaitingCompletionCount == 0 && awaitingResubmissionCount == 0 && awaitingAuthorizationCount == 0 && awaitingSubmissionCount == 0">
          There are no PEAs requiring your action.
        </div>
        <div v-if="awaitingApprovalsCount > 0 || upcomingApprovalsCount > 0">
          <h3>PEAs for your Approval</h3>
          <el-tabs type="border-card">
            <el-tab-pane v-if="awaitingApprovalsCount > 0">
              <span slot="label" >
                Awaiting Your Approval
                <el-badge :value="awaitingApprovalsCount"/>
              </span>
              The following PEAs are awaiting your approval.  These PEAs can not progress any further until you make a decision.
              <br> <br>
              <welcome-table :type="1"></welcome-table>
            </el-tab-pane>
            <el-tab-pane v-if="upcomingApprovalsCount > 0">
              <span slot="label" >
                Upcoming Approvals
                <el-badge :value="upcomingApprovalsCount"/>
              </span>
              The following PEAs have been submitted and will need your approval in the future but
              have yet to reach your authorization level.   You can make a decision on them
              now if you wish or wait until the PEA reaches your level and you will be emailed
              notification.
              <br> <br>
              <welcome-table :type="2"></welcome-table>
            </el-tab-pane>
          </el-tabs>
        </div>
        <br /><br />
        <div v-if="recentAuthorizedCount > 0 || awaitingCompletionCount > 0 || awaitingResubmissionCount > 0 || awaitingAuthorizationCount > 0 || awaitingSubmissionCount > 0">
          <h3>Your PEAs</h3>
          <el-tabs type="border-card">
            <el-tab-pane v-if="recentAuthorizedCount > 0">
              <span slot="label" >
                Recently Authorized
                <el-badge :value="recentAuthorizedCount"/>
              </span>
              The following PEAs have been approved in the past week
              <br> <br>
              <welcome-table :type="3"></welcome-table>
            </el-tab-pane>
            <el-tab-pane v-if="awaitingCompletionCount > 0">
              <span slot="label" >
                Awaiting Completion
                <el-badge :value="awaitingCompletionCount"/>
              </span>
              The following PEAs have been approved but you have yet to mark them as completed.
              As the project progresses you should update the Cost to Date field on a weekly basis.
              When the project is complete you should mark it as complete using the Mark Completed button at the bottom of the PEA.
              <br> <br>
              <welcome-table :type="4"></welcome-table>
            </el-tab-pane>
            <el-tab-pane v-if="awaitingResubmissionCount > 0">
              <span slot="label" >
                Awaiting Resubmission
                <el-badge :value="awaitingResubmissionCount"/>
              </span>
              The following PEAs have been Denied With Conditions and are awaiting resubmission.
              <br> <br>
              <welcome-table :type="5"></welcome-table>
            </el-tab-pane>
            <el-tab-pane v-if="awaitingAuthorizationCount > 0">
              <span slot="label" >
                Awaiting Authorization
                <el-badge :value="awaitingAuthorizationCount"/>
              </span>
              You have submitted the following PEAs that have yet to be fully authorized.
              If any of the PEAs listed below are no longer relevant ( eg  replaced by a newer version)
              then you should open them by clicking on the PEA links below in turn and use the "Withdraw"
              option from the bottom of that page to remove it from the list actively requiring approval.
              <br> <br>
              <welcome-table :type="6"></welcome-table>
            </el-tab-pane>
            <el-tab-pane v-if="awaitingSubmissionCount > 0">
              <span slot="label" >
                Awaiting Submission
                <el-badge :value="awaitingSubmissionCount"/>
              </span>
              The following PEAs are In Preparation and are awaiting submission.  If you
              no longer intend to submit any of these PEAs then please delete them.   You can
              do this by clicking on the link for a PEA and pressing the Delete button at the
              bottom of the page.
              <br> <br>
              <welcome-table :type="7"></welcome-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'welcome',
  data () {
    return {
      alertType: '',
      alertTitle: '',
      callInfo: '',
      awaitingApprovalsCount: 0,
      upcomingApprovalsCount: 0,
      recentAuthorizedCount: 0,
      awaitingCompletionCount: 0,
      awaitingResubmissionCount: 0,
      awaitingAuthorizationCount: 0,
      awaitingSubmissionCount: 0,
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['getAccessToken', 'getDataToken', 'getSingleFullAccountData', 'getUserDetails']),
    fetchData: function () {
      this.getAccessToken(this.$msalInstance).then((response) => {
        this.isLoading = true
        var call = '/getMyStats'
        this.$axios.get(call).then((response) => {
          this.awaitingApprovalsCount = response.data.awaitingApprovalsCount
          this.upcomingApprovalsCount = response.data.upcomingApprovalsCount
          this.recentAuthorizedCount = response.data.recentAuthorizedCount
          this.awaitingCompletionCount = response.data.awaitingCompletionCount
          this.awaitingResubmissionCount = response.data.awaitingResubmissionCount
          this.awaitingAuthorizationCount = response.data.awaitingAuthorizationCount
          this.awaitingSubmissionCount = response.data.awaitingSubmissionCount
          this.isLoading = false
          this.alertTitle = ''
        }).catch(reject => {
          this.isLoading = false
          helperMethods.showNotification(this, 'Error Retrieving PEA Welcome Stats', reject.body, 'error', 30000, '')
        })
      })
    },
    fetchTokens: function () {
      this.isLoading = true
      const accounts = this.$msalInstance.getAllAccounts()
      this.$msalInstance.setActiveAccount(accounts[0])
      this.$store.state.userInfo.account = accounts[0]
      this.getDataToken(this.$msalInstance).then(() => {
        return this.getSingleFullAccountData(this.$store.state.userInfo.account.username)
      }).then(() => {
        return this.getUserDetails(this.$store.state.userInfo.fullAccount.onPremisesSamAccountName)
      }).then(() => {
        this.fetchData()
      }).catch((error) => {
        this.isLoading = false
        helperMethods.showNotification(this, 'Error Retrieving PEA Welcome Stats', error.body, 'error', 30000, '')
      })
    }
  },
  computed: {
    ...mapGetters(['dataToken'])
  },
  created: function () {
    this.fetchTokens()
  },
  watch: {
    dataToken: function () {
      this.fetchTokens()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.peaTableComponent {
   padding-left: 25px;
}

.col-xl-10 {
  padding-left: 25px;
}

.el-tabs {
  box-shadow: none;
}

@media (max-width: 991px){
  .peaTableComponent {
    padding-left: 15px;
  }
}
</style>
